import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Segment, Dimmer, Loader } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { LineChart, AreaChart, Area, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { updateDataAtLeast } from '../actions/updateDataAtLeast';

class GraphAtLeast extends Component {
  state={active: true, errorMessage: "Awaiting valid input..."}; // active = true when data are valid for graphing

  componentWillReceiveProps (nextProps) {
    const { pageViews, uniqueVisitors, impressions } = nextProps;
    const avg = pageViews / uniqueVisitors;

    if (avg < 1) {
      console.log("Error -- avg is less than one: ", avg);
      this.setState({ active: false, errorMessage: "Waiting for graphable input -- page views are fewer than the number of unique visitors..." }, () => {
        console.log(this.state.active);
        console.log(this.state.errorMessage);
      });
    } else if (impressions > pageViews) {
      console.log("Error -- impressions > pageViews");
      this.setState({ active: false, errorMessage: "Waiting for graphable input -- impressions to be purchased exceeds the number of available page views..."}, () => {
        console.log(this.state.active);
        console.log(this.state.errorMessage);
      });
    } else if (avg > 500) {
      console.log("Error -- ratio between page views and visitors is too high");
      this.setState({ active: false, errorMessage: "Waiting for graphable input-- ratio between page views and visitors is too high..." }, () => {
        console.log(this.state.active);
        console.log(this.state.errorMessage);
      });
    } else {
      console.log("Success -- input is legit");
      this.setState({ active: true, errorMessage: "Graphing..." }, () => {
         console.log(this.state.active);
         console.log(this.state.errorMessage);
      });
    }
  }

  toPercent = (decimal, fixed = 0) => {
    return `${(decimal * 100).toFixed(fixed)}%`;
  };

  iFact = (num) => {
    let val = 1;

    if (num === Infinity || num === "Infinity")
      return 0
    else if (num === "NaN" || isNaN(num))
      return 0
    else if (num < 0)
      return -1;
    else if (num === 0)
      return 1;
    else {
      for (let i = 2; i <= num; i++)
        val *= i;
      return val;
    }
  }

  calculateGraphAtLeast = () => {
    const { pageViews, uniqueVisitors, impressions, dispatch } = this.props;
    let pov = (impressions / pageViews); // percentage of views
    let avg = 0;

    if (isNaN(avg)){
      avg = 0;
    } else {
      avg = pageViews / uniqueVisitors;
    }

    let upperAvg = Math.ceil(avg);
    let lowerAvg = Math.floor(avg);
    let upperPoint = 0;
    let lowerPoint = 0;
    let upperPointPrecise = 0;
    let lowerPointPrecise = 0;
    let upperStore = 0;
    let lowerStore = 0;
    let graphAtLeastData = [];

    // "store" variables are used to track values at cycle (i - 1)
    for (let i = 0; i < 15; i++) {
      upperPointPrecise = parseFloat( (this.iFact(upperAvg) / (this.iFact(i) * this.iFact(upperAvg - i))) * Math.pow(pov, i) * Math.pow((1 - pov), (upperAvg - i)) );

      lowerPointPrecise = parseFloat( (this.iFact(lowerAvg) / (this.iFact(i) * this.iFact(lowerAvg-i))) * Math.pow(pov, i) * Math.pow((1 - pov), (lowerAvg - i)) );

      if(isNaN(upperPointPrecise) || upperPointPrecise < 0) upperPointPrecise = 0;
      if(isNaN(lowerPointPrecise) || lowerPointPrecise < 0) lowerPointPrecise = 0;

      if( i === 0 ) {
        upperPoint = upperPointPrecise;
        lowerPoint = lowerPointPrecise;
        upperStore = upperPoint;
        lowerStore = lowerPoint;
      } else if( i === 1 ) {
        upperPoint = 1 - upperStore;
        lowerPoint = 1 - lowerStore;
        upperStore = upperPointPrecise + upperStore;
        lowerStore = lowerPointPrecise + lowerStore;
      } else if( i > 1 ) {
        upperPoint = 1 - upperStore;
        lowerPoint = 1 - lowerStore;
        upperStore = upperStore + upperPointPrecise;
        lowerStore = lowerStore + lowerPointPrecise;
      }

      let rangeArray = [upperPoint, lowerPoint];
      if( i === 0 ){
        rangeArray = [1, 1];
      }
      let chartObject = {'name': i, 'range': rangeArray};

      graphAtLeastData.push(chartObject);

    }
    dispatch(updateDataAtLeast(graphAtLeastData));
    return (graphAtLeastData);
  }

  render() {
    let graphAtLeastData = this.calculateGraphAtLeast();
    let clone = graphAtLeastData.slice(0);
    clone.shift();

    { if (this.state.active == true) {
        return(
          <Container>
            <Segment basic>
              <h3>"At Least" Impressions Per Visitor</h3>
              <ResponsiveContainer width={'100%'} height={300}>
                <AreaChart
                  data={clone}
                  stackOffset="expand"
                >
                  <defs>
                    <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#8884d8" stopOpacity={0.8}/>
                      <stop offset="95%" stopColor="#8884d8" stopOpacity={0}/>
                    </linearGradient>
                  </defs>
                  <XAxis dataKey="name"/>
                  <YAxis tickFormatter={this.toPercent} />
                  <CartesianGrid strokeDasharray="3 3"/>
                  <Tooltip/>
                  <Legend />
                  <Area
                    type="monotone"
                    dataKey="range"
                    stroke="#8884d8"
                    strokeWidth={1}
                    fillOpacity={1}
                    fill="url(#colorUv)"
                    activeDot={{r: 8}}
                  />
                </AreaChart>
              </ResponsiveContainer>
            </Segment>
          </Container>
        )
      } else {
        return (
          <Dimmer active inverted size='huge'>
            <Loader inverted content={this.state.errorMessage} />
          </Dimmer>
        )
      }
    }
  }
}

const mapStateToProps = state => {
  return {
    impressions: state.stats.impressions,
    pageViews: state.stats.pageViews,
    uniqueVisitors: state.stats.uniqueVisitors
  }
}

export default connect(mapStateToProps)(GraphAtLeast);



// WEBPACK FOOTER //
// ./src/components/GraphAtLeast.js